import React from 'react';
import { useTranslation } from 'react-i18next';
import './Hero.css';
import englishScreenshot from '../assets/main page English fixed.JPG';
import hebrewScreenshot from '../assets/main page Hebrew fixed.JPG';

const Hero = () => {
  const { t, i18n } = useTranslation();

  const lang = (i18n && i18n.language) ? i18n.language.split('-')[0] : 'en';
  const screenshotSrc = lang === 'he' ? hebrewScreenshot : englishScreenshot;

  const handleStartNow = () => {
    const appUrl = process.env.REACT_APP_APP_URL || 'https://app.glowapp.me';
    if (appUrl) window.open(appUrl, '_blank');
  };

  const stats = [
    { value: t('heroStat1Value'), label: t('heroStat1Label') },
    { value: t('heroStat2Value'), label: t('heroStat2Label') },
    { value: t('heroStat3Value'), label: t('heroStat3Label') },
  ];

  return (
    <section className="hero" aria-label="Hero section">
      <div className="hero-petal hero-petal--1" aria-hidden="true" />
      <div className="hero-petal hero-petal--2" aria-hidden="true" />
      <div className="hero-petal hero-petal--3" aria-hidden="true" />
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className={`hero-title ${lang === 'he' ? 'hero-title--he' : ''}`}>{t('heroTitle')}</h1>
            <h2 className="hero-subtitle">{t('heroSubtitle')}</h2>
            <div className="hero-cta">
              <button onClick={handleStartNow} className="btn btn-primary btn-large">
                {t('getTheApp')}
              </button>
              <a href="#how-it-works" className="btn btn-secondary btn-large">
                {t('learnMore')}
              </a>
            </div>
            <div className="hero-stats">
              {stats.map((stat) => (
                <div key={stat.label} className="hero-stat">
                  <span className="hero-stat-value">{stat.value}</span>
                  <span className="hero-stat-label">{stat.label}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="hero-visual">
            <div className="phone-mockup" aria-label={t('appScreenshot')}>
              <div className="phone-screen">
                <img
                  src={screenshotSrc}
                  className="app-screenshot-image"
                  alt={lang === 'he' ? 'תצוגת אפליקציה' : 'App main page screenshot'}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
